(function () {
  if (!window.visualViewport) return;

  var stickyBtn = document.querySelector('.product-form__mobile-sticky-button');
  if (!stickyBtn) return;

  var initialHeight = window.innerHeight;
  var KEYBOARD_THRESHOLD = 150;

  function onViewportResize() {
    var heightDiff = initialHeight - window.visualViewport.height;
    var isKeyboardOpen = heightDiff > KEYBOARD_THRESHOLD;
    stickyBtn.classList.toggle('keyboard-open', isKeyboardOpen);
  }

  window.visualViewport.addEventListener('resize', onViewportResize);
})();
